
// import React from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// import Navbar from "./Navbar";
// import Login from "./Login";
// import Dashboard from "./Dashboard";
// // import About from "./About";
// import Settings from "./Settings";
// import Dashboard2 from "./Dashboard2";


// import HistoryPage from "./HistoryPage";
// import ReportPage from "./Report";


// const App = () => {
//   return (
//     <Router>
//       <Navbar />
  
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           {/* <Route path="/about" element={<  />} /> */}
//           <Route path="/settings" element={<Settings />} />
//           <Route path="/dashboard2" element={<Dashboard2 />} />
//           <Route path="/HistoryPage" element={<HistoryPage />} />

//           <Route path="/Report" element={<ReportPage />} />        </Routes>
 
//     </Router>
//   );
// };

// export default App;
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Navbar from "./Navbar";
import Login from "./Login";
import Dashboard from "./Dashboard";
// import About from "./About";
import Settings from "./Settings";
import Dashboard2 from "./Dashboard2";

//import MqttClient from "./MqttClient";
import HistoryPage from "./HistoryPage";
import ReportPage from "./Report";
import Admin from "./Admin";
import ManageUsers from "./New_station";
import SystemLogs from "./SystemLogs";
import AdminSettings from "./AdminSettings";
import Provision from "./device_provision"
import AddConfig from "./AddConfig";
import EditConfig from "./EditConfig";
import NewDeviceJob from "./NewDeviceJob";
import JobStatus from "./JobStatus";


const App = () => {
  return (
    <Router>
      <Navbar />
  
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
         {/*<Route path="/about" element={<MqttClient />} />*/ } 
          <Route path="/settings" element={<Settings />} />
          <Route path="/dashboard2" element={<Dashboard2 />} />
          <Route path="/HistoryPage" element={<HistoryPage />} />
           <Route path="/admin" element={<Admin/>} >
           <Route path="users" element={<ManageUsers />} />
  <Route path="logs" element={<SystemLogs />} />
  <Route path="settings" element={<AdminSettings />} />
  <Route path="Provision" element={< Provision  />} />
  <Route path="device-config/new" element={< AddConfig  />} />
  <Route path="device-config/edit" element={< EditConfig  />} />
  <Route path="device-config/job-new" element={< NewDeviceJob  />} />
  <Route path="device-config/status" element={< JobStatus  />} />
  </Route>
          <Route path="/Report" element={<ReportPage />} />        </Routes>
 
    </Router>
  );
};

export default App;